import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-text-slate-500 tw-text-sm" }

import { computed, ref } from "vue"
  import { QSelect } from "quasar"
  
  import { TitleOptions } from "src/const/select-options"
 
  
export default /*@__PURE__*/_defineComponent({
  __name: 'TitleSelect',
  props: {
    modelValue: {
      type: Number as () => number | null,
      default: null,
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    'update:modelValue'
  ],
  setup(__props, { expose: __expose, emit: __emit }) {

  const props = __props

  const value = computed<number | null>({
    get() {
      if (props.modelValue) {
        return props.modelValue
      }
      else {
        return null
      }
    },
    set(value: number | null) {
      emit('update:modelValue', value)
    }
  })

  const emit = __emit

  const titleSelectRef = ref<QSelect | null>(null);
  function validate(){
    return titleSelectRef.value!.validate();
  }
  __expose({ validate })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(QSelect), {
    modelValue: value.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
    modelModifiers: { number: true },
    options: _unref(TitleOptions),
    ref_key: "titleSelectRef",
    ref: titleSelectRef,
    rules: [val => (__props.required === true && !!val) || !__props.required || 'Required'],
    "emit-value": "",
    "popup-content-class": "tw-text-sm limit-dd-height",
    label: value.value ? undefined : 'Select a title...',
    "map-options": "",
    "data-cy": "titleSelect",
    "dropdown-icon": "mdi-chevron-down",
    class: _normalizeClass(!titleSelectRef.value?.hasError ? 'tw-shadow-sm' : ''),
    outlined: "",
    dense: "",
    "data-clarity-unmask": "true"
  }, {
    selected: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(TitleOptions).find(t => t.value === value.value)?.label), 1)
    ]),
    _: 1
  }, 8, ["modelValue", "options", "rules", "label", "class"]))
}
}

})